import React from "react";
import { useFieldArray } from "react-hook-form";
import Button from "../../../Common/Button/Button";
import Input from "../../../Common/Input/Input";
import PlusIcon from "../../../Common/SvgIcons/CommonIcons/PlusIcon";
import UploadImageIcon from "../../../Common/SvgIcons/CommonIcons/UploadImageIcon";
// import CrossIcon from "../../../Common/SvgIcons/SocialIcons/CrossIcon";
import DeleteIcon from "../../../Common/SvgIcons/TableIcons/DeleteIcon";
import Tooltip from "../../../Common/ToolTip/Tooltip";
import { useSelector } from "react-redux";
import classes from "./AddQuizAnswerArr.module.scss";
import { FormattedMessage } from "react-intl";

const AddQuizAnswerArr = ({
  activeQuestionIndex,
  control,
  activeTab,
  questionListWatch,
  handleThumbnailSelect,
  isDistributed,
  shotclassType,
  errors,
  trigger,
  setValue,
}) => {
  const commonState = useSelector((state) => state.commonReducer);
  const { colors } = commonState;
  const {
    fields: answersFields,
    append: appendAnswer,
    remove: removeAnswer,
  } = useFieldArray({
    control,
    name: `QuestionsList.${activeQuestionIndex}.AnswersList`,
  });

  return activeTab === 1 ? (
    <div className={classes.addQuizAnswerArr__answersFields}>
      {answersFields.map((item, index, ansArr) => {
        let isImageAdded =
          questionListWatch?.[activeQuestionIndex]?.AnswersList?.filter(
            (answer) => answer?.AnswerImage !== ""
          )?.length > 0;
        return (
          <div
            key={item.id}
            className={classes.addQuizAnswerArr__answersFields__answerField}
          >
            <Input
              name={`QuestionsList.${activeQuestionIndex}.AnswersList.${index}.Answer`}
              label={`Answer ${index + 1}`}
              labelMsg={
                isImageAdded
                  ? `(Max : 60 Characters)`
                  : `(Max : 250 Characters)`
              }
              placeholder={
                isImageAdded ? `Answer ${index + 1}` : `Answer ${index + 1}`
              }
              labelColor="light"
              error={
                errors?.QuestionsList?.[activeQuestionIndex]?.AnswersList?.[
                  index
                ]?.Answer?.message
              }
              errorPosition="absolute"
              type="textarea"
              maxLength={isImageAdded ? 60 : 250}
              disabled={shotclassType === "view"}
              onChange={() => {
                trigger([`QuestionsList.${activeQuestionIndex}.AnswersList`]);
              }}
              inputStyles={{ paddingRight: "3.5rem" }}
            />
            <div
              className={
                classes.addQuizAnswerArr__answersFields__answerField__radio
              }
              disabled={shotclassType === "view"}
            >
              <Input
                name={`QuestionsList.${activeQuestionIndex}.IsCorrect`}
                type="radio"
                width="2"
                height="2"
                value={`${index}`}
                disabled={shotclassType === "view"}
              />
            </div>
            <Input
              key={item.id}
              type="file"
              label="Add Image"
              name={`QuestionsList.${activeQuestionIndex}.AnswersList.${index}.AnswerImage`}
              placeholder=" "
              labelColor="light"
              accept=".jpeg,.png,.bmp,.jpg"
              error={
                errors?.QuestionsList?.[activeQuestionIndex]?.AnswersList?.[
                  index
                ]?.AnswerImage?.message
              }
              errorPosition="absolute"
              hidden={true}
              fileInputIcon={UploadImageIcon}
              width={10}
              fileInputButtonWidth={8}
              fileInputName={
                questionListWatch?.[activeQuestionIndex]?.AnswersList?.[index]
                  .AnswerImage?.FileName
              }
              handleCancelFileInput={() =>
                trigger([`QuestionsList.${activeQuestionIndex}.AnswersList`])
              }
              handleClickFileButton={() => {
                handleThumbnailSelect(
                  `QuestionsList.${activeQuestionIndex}.AnswersList.${index}.AnswerImage`
                );
              }}
              gap={
                // questionListWatch?.[activeQuestionIndex]?.AnswersList?.[index]
                //   ?.AnswerImage
                //   ? 1.5
                // :
                1.1
              }
              disabled={shotclassType === "view"}
            />
            {index !== 0 && !isDistributed && (
              <Tooltip content="Delete" direction="bottom">
                <span
                  onClick={() => {
                    if (shotclassType !== "view") {
                      removeAnswer(index);
                      const isCorrectIndex =
                        questionListWatch?.[activeQuestionIndex]?.IsCorrect;
                      if (isCorrectIndex && index <= isCorrectIndex) {
                        setValue(
                          `QuestionsList.${activeQuestionIndex}.IsCorrect`,
                          ""
                        );
                      }
                    }
                  }}
                  className={
                    classes.addQuizAnswerArr__answersFields__answerField__removeIcon
                  }
                >
                  <DeleteIcon fill={colors.theme} />
                </span>
              </Tooltip>
            )}
            {index === ansArr.length - 1 &&
              !errors?.QuestionsList?.[activeQuestionIndex]?.AnswersList?.[
                index
              ]?.Answer?.message &&
              !errors?.QuestionsList?.[activeQuestionIndex]?.AnswersList?.[
                index
              ]?.AnswerImage?.message && (
                <div
                  className={
                    classes.addQuizAnswerArr__answersFields__answerField__error
                  }
                >
                  {
                    // questionListWatchTemp?.[
                    //   activeQuestionIndex
                    // ]?.AnswersList?.filter((answer) => answer?.Answer !== "")
                    //   ?.length > 0 &&
                    // !errors?.QuestionsList?.message &&
                    errors?.QuestionsList?.[activeQuestionIndex]?.AnswersList
                      ?.message ||
                      errors?.QuestionsList?.[activeQuestionIndex]?.IsCorrect
                        ?.message
                  }
                </div>
              )}
          </div>
        );
      })}

      <div
        className={classes.addQuizAnswerArr__answersFields__addMultiContainer}
      >
        <Button
          label="Add New"
          height="3"
          width="11.3"
          icon={PlusIcon}
          onClick={() => {
            appendAnswer({ Answer: "", AnswerImage: "" });
          }}
          light
          type="button"
          disabled={shotclassType === "view" || isDistributed}
        />
        {/* <Input
          label={"Allow Multi-Select"}
          name={`QuestionsList.${activeQuestionIndex}.MultiSelect`}
          type="checkbox"
          labelColor={colors.theme}
          direction="row-reverse"
          width="2"
          height="2"
        /> */}
      </div>
      <Input
        name={`QuestionsList.${activeQuestionIndex}.Explanation`}
        label="Enter Answer Explanation (Optional)"
        placeholder="Enter Answer Explanation Here"
        labelColor="light"
        error={
          errors?.QuestionsList?.[activeQuestionIndex]?.Explanation?.message
        }
        type="textarea"
        disabled={shotclassType === "view"}
        maxLength={250}
      />
    </div>
  ) : activeTab === 2 ? (
    <div className={classes.addQuizAnswerArr__trueOrFalse}>
      Select answer is true or false
      <div className={classes.addQuizAnswerArr__trueOrFalse__fields}>
        <Input
          label= {<FormattedMessage id="TRUE_TEXT" />}
          name={`QuestionsList.${activeQuestionIndex}.IsCorrect`}
          type="radio"
          width="2"
          height="2"
          value="True"
          direction="row-reverse"
          disabled={shotclassType === "view"}
          disableLabelClick
        />
        <Input
          label={<FormattedMessage id="FALSE_TEXT" />}
          name={`QuestionsList.${activeQuestionIndex}.IsCorrect`}
          type="radio"
          width="2"
          height="2"
          value="False"
          direction="row-reverse"
          disabled={shotclassType === "view"}
          disableLabelClick
        />
      </div>
      <div className={classes.addQuizAnswerArr__trueOrFalse__error}>
        {errors?.QuestionsList?.[activeQuestionIndex]?.IsCorrect?.message}
      </div>
      <Input
        name={`QuestionsList.${activeQuestionIndex}.Explanation`}
        label="Enter Answer Explanation (Optional)"
        placeholder="Enter Answer Explanation Here"
        labelColor="light"
        error={
          errors?.QuestionsList?.[activeQuestionIndex]?.Explanation?.message
        }
        type="textarea"
        disabled={shotclassType === "view"}
      />
    </div>
  ) : (
    <></>
  );
};

export default AddQuizAnswerArr;
